import React from "react";

interface ContainerProps {
  img: string;
  heading: string;
  content: string;
}

const Heading: React.CSSProperties = {
  fontFamily: "DM Sans",
  fontWeight: "700",
};

const ContainerElements: React.FC<ContainerProps> = ({
  img,
  heading,
  content,
}) => {
  return (
    <div
      id="FeatureElement"
      className="gap-3.5 w-72 h-full flex flex-1 flex-col py-0 px-3.5"
    >
      <div id="imageBox" className=" flex items-center justify-center">
        <img className="w-14" src={img} alt="People.jpg" />
      </div>
      <div
        id="Heading"
        style={Heading}
        className="text-white text-16 md:text-[18px] font-bold leading-26 tracking-0 text-center"
      >
        {heading}
      </div>
      <div
        id="content"
        style={{ ...Heading, fontWeight: "500" }}
        className="text-white  text-16 md:text-[18px] font-medium leading-26 tracking-0 text-center"
      >
        {content}
      </div>
    </div>
  );
};

export default ContainerElements;
